<script setup lang="ts">
  import { useUiStore } from '~/store/ui';

  interface INavItem {
    title: string;
    icon: string;
    to?: string;
    onClick?: () => void;
    isHighlighted?: boolean;
    badge?: number;
  }

  const route = useRoute();

  const items = computed<INavItem[]>(() => [
    {
      title: 'Lobby',
      icon: 'SvgoLobby',
      to: '/lobby',
    },
    {
      title: 'PvP',
      icon: 'SvgoPvp',
      to: '/playervsplayer',
    },
    {
      title: 'Deposit',
      icon: 'SvgoDepositAdd',
      isHighlighted: true,
      onClick: () => stores.modals.showCashierModal(),
    },
    {
      title: 'SoloPlay',
      icon: 'SvgoSoloPlay',
      to: '/soloplay',
    },
    {
      title: 'Inbox',
      icon: 'SvgoBell',
      badge: stores.firebase.filteredAlerts.length,
      onClick: () => useUiStore().toggleNotificationPanel(true),
    },
  ]);
  const { activeBreakpoint } = useDeviceType();
  const isMobile = computed(() => ['xxs', 'xs', 'sm'].includes(activeBreakpoint.value));

  function handleClick(item: INavItem) {
    if (item.to) {
      navigateTo(item.to);
    } else if (item.onClick) {
      item.onClick();
    }
  }

  function isActiveRoute({ to }: INavItem) {
    if (!to) return false;
    return route.path === to;
  }
</script>

<template>
  <div
    class="contain-strict fixed z-100 bottom-0 w-full bg-[#333639] h-[4.5rem] grid grid-cols-5 gap-0.5 pt-0.5"
    :class="{ hidden: !isMobile }"
  >
    <div
      v-for="item in items"
      :key="item.title"
      class="flex flex-col items-center justify-center gap-1.5"
      :class="{
        'bg-primary': item.isHighlighted,
        'bg-[#101317]': !item.isHighlighted,
        'active-route': isActiveRoute(item),
      }"
      @click="handleClick(item)"
    >
      <div
        v-if="item.badge"
        class="absolute top-2.5 right-4 tabular-nums pl-1 pr-[0.3125rem] flex items-center h-4 bg-[#DC0000] rounded-full text-white text-center font-inter text-xs not-italic font-black leading-none"
      >
        {{ item.badge }}
      </div>
      <component
        :is="item.icon"
        :filled="!isActiveRoute(item)"
        class="[.active-route_&]:text-primary"
        :class="{
          'h-[1.125rem]': !item.isHighlighted,
          'h-6 -mt-[5px]': item.isHighlighted,
        }"
      />
      <span
        class="text-center font-barlow leading-none text-white [.active-route_&]:text-primary"
        :class="{
          'text-[11px] font-medium': !item.isHighlighted,
          'text-sm font-bold': item.isHighlighted,
        }"
      >
        {{ item.title }}
      </span>
    </div>
  </div>
</template>
